module.exports = __webpack_public_path__ + "img/identifying-and-safeguarding-personally-identifiable-information.e2bfd98b.png";